import { render, staticRenderFns } from "./ArchiveRequestRecordsDialog.vue?vue&type=template&id=1c76dd1c&"
import script from "./ArchiveRequestRecordsDialog.vue?vue&type=script&lang=js&"
export * from "./ArchiveRequestRecordsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports